﻿<div *ngIf="!importCompleted">
    <h4>
        {{ importInProgress ? 'Importing Data' : 'Import Completed' }}
    </h4>
    <div class="progress-section">
        <div class="progress-bar">
            <div class="progress" [ngStyle]="{ width: importProgress + '%' }"></div>
        </div>
        <p>{{ importProgress }}% Completed</p>
    </div>
</div>

<div *ngIf="importCompleted">
    <div class="import-summary">
        <ng-container *ngIf="!loadingTotals">
            <h4>Review Imported Premium Data</h4>
            <!-- Show Error Section Toggle Button -->
            <div *ngIf="importErrors && importErrors.length !== 0" style="margin-bottom: 16px;">
                <button (click)="toggleError()" class="button-small">
                    {{ showErrors ? 'Hide Sample Errors' : 'Show Sample Errors' }}
                </button>
            </div>
            <!-- Show Error Section -->
            <ng-container *ngIf="showErrors">
                <div *ngIf="showErrors" class="import-errors pt-2">
                    <h3 class="error-header">Import Batch Errors</h3>
                    <p class="error-subheading" style="font-size: 14px; color: #666; margin-top: 5px; margin-bottom: 15px;">
                        <ng-container *ngIf="errorRowCount > 0">
                            {{ errorRowCount }} {{ errorRowCount === 1 ? 'row' : 'rows' }} contained errors while importing the batch.
                        </ng-container>
                        <ng-container *ngIf="errorRowCount === 0 && filteredErrors.length > 0">
                            Errors occurred during import.
                        </ng-container>
                        See {{ filteredErrors.length }} {{ filteredErrors.length === 1 ? 'sample' : 'samples' }} below.
                    </p>
                    <div class="totals">
                        <p>Some errors occured while importing the batch. See details below.</p>
                    </div>
                    <table class="error-details-table">
                        <thead>
                            <tr>
                                <th>Row</th>
                                <th>Column</th>
                                <th>Value</th>
                                <th>Message</th>
                                <th>Attempted Format</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let err of filteredErrors">
                                <td>{{ err.row }}</td>
                                <td>{{ err.column }}</td>
                                <td>{{ formatErrorValue(err.value) }}</td>
                                <td>{{ err.message }}</td>
                                <td>{{ err.attemptedFormats || err.expectedType }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <button (click)="deletePremiumBatch()" class="button-small">
                        Delete and Retry Premium Batch Import
                    </button>
                </div>
            </ng-container>

            <!-- Combined Import Statistics and Summary -->
            <div class="import-statistics" style="margin-top: 30px; margin-bottom: 20px;">
                <h4>Import Statistics</h4>
                <table class="summary-details-table" style="margin-top: 10px;">
                    <tbody>
                        <tr>
                            <th>Rows Marked for Import:</th>
                            <td><strong>{{ formatNumber(totalRows) }}</strong></td>
                        </tr>
                        <tr>
                            <th>Rows Imported Successfully:</th>
                            <td style="color: #28a745;"><strong>{{ formatNumber(rowsImported) }}</strong></td>
                        </tr>
                        <tr>
                            <th>Rows Failed:</th>
                            <td style="color: #dc3545;"><strong>{{ formatNumber(errorRowCount > 0 ? errorRowCount : (totalRows - rowsImported)) }}</strong></td>
                        </tr>
                        <tr>
                            <th>Total CI/PT Premium:</th>
                            <td>{{ formatNumber(totals.totalCiPtPremium)  }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
         </ng-container>
    </div>
</div>

<div class="review-import-data">
    <div class="import-preview">
        <!-- Show Data Section -->
        <ng-container>
            <button (click)="toggleSampleData()">
                {{ showData ? 'Hide Imported Rows' : 'Show Imported Rows' }}
            </button>
            <div *ngIf="loading" class="loading-indicator" style="padding-top: 10px;">
                <div class="spinner"></div>
                Loading data, please wait...
            </div>
            <div *ngIf="showData && !loading">
                <div *ngIf="sampleRows.length === 0" class="no-data">
                    No sample data available for this premium batch.
                </div>
                <div class="data-preview-container" *ngIf="sampleRows.length > 0">
                    <table class="data-preview-table">
                        <thead>
                            <tr>
                                <th>Policy Number</th>
                                <th>Amount Declared</th>
                                <th>Declaration Date</th>
                                <th>CI Premium</th>
                                <th>PT Premium</th>
                                <th>Import CI & PT value as total</th>
                                <th>Credit Limit Fees</th>
                                <th>Rapid Response Fees</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of sampleRows">
                                <td>{{ row.policyNumber || '-' }}</td>
                                <td>{{ row.declarationAmount || '-' }}</td>
                                <td>{{ row.declarationDate || '-' }}</td>
                                <td>{{ row.ptPciPremiumremium !== null && row.ciPremium !== undefined ? row.ciPremium : '-' }}</td>
                                <td>{{ row.ptPremium !== null && row.ptPremium !== undefined ? row.ptPremium : '-' }}</td>
                                <td>{{ row.totalImportCipt !== null && row.totalImportCipt !== undefined ? row.totalImportCipt : '-' }}</td>
                                <td>{{ row.creditLimitFees !== null && row.creditLimitFees !== undefined ? row.creditLimitFees : '-' }}</td>
                                <td>{{ row.rapidResponseFees !== null && row.rapidResponseFees !== undefined ? row.rapidResponseFees : '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>
    </div>

</div>